import React from 'react';
import PropTypes from 'prop-types';
import logger from 'src/logger';
import {
  ensureAmazon,
  onAmazonSetupWidget,
  setAmazonClientId,
  logoutAmazonUser,
  authorizeAmazonUser,
} from './helpers';

export class Amazon extends React.Component {
  static propTypes = {
    amazonDetails: PropTypes.shape({
      widgetUrl: PropTypes.string.isRequired,
      clientId: PropTypes.string.isRequired,
      merchantId: PropTypes.string.isRequired,
    }).isRequired,
    authCompleteRedirectUrl: PropTypes.string,
    handleAuthComplete: PropTypes.func,
    onClick: PropTypes.func,
    /**
     * If set to true, it will call a method which authorizes an
     * Amazon user on componentDidMount if user data exists in cookies
     */
    autoLogin: PropTypes.bool,
    /**
     * If set to true, it will call an Amazon method which will log the user out of Amazon
     */
    autoLogout: PropTypes.bool,
  };

  componentDidMount() {
    const { amazonDetails, authCompleteRedirectUrl, handleAuthComplete, autoLogout, autoLogin } = this.props;
    onAmazonSetupWidget(amazonDetails.widgetUrl, () => {
      ensureAmazon().then(() => {
        if (autoLogout) {
          logoutAmazonUser();
        }
        setAmazonClientId(amazonDetails.clientId);
        const authorization = () => authorizeAmazonUser(
          {
            scope: 'profile postal_code payments:widget payments:shipping_address',
            popup: 'true',
            interactive: 'auto'
          },
          // Amazon receives either a callback, or a string to which it will redirect on completion.
          handleAuthComplete || authCompleteRedirectUrl
        );
        /* eslint-disable new-cap */
        window.OffAmazonPayments.Button('amazon-pay-btn', amazonDetails.merchantId, {
          /* eslint-enable new-cap */
          type: 'PwA',
          color: 'gold',
          size: window.devicePixelRatio > 1 ? 'large' : 'medium',
          authorization,
          onError: error => {
            logger.warn(`${error.getErrorCode()}: ${error.getErrorMessage()}`);
          },
        });

        if (autoLogin) {
          authorization();
        }
      });
    });
  }

  render() {
    return (
      <div
        onClick={this.props.onClick}
        id={`amazon-pay-btn`}
        className="button button--unstyled button--full-width button--amazon"
      />
    );
  }
}

export default Amazon;



// WEBPACK FOOTER //
// ./src/client/js/view/components/Checkout/Amazon/Amazon.js